import { BrowserRouter, Route, Routes } from 'react-router-dom';
import React, { createContext } from 'react';
import ApplicationsTable from './applications/applications-table';
import CreateApplicationWizard from './applications/create-application';
import ApplicationDetails from './applications/application-details';
import { Scope } from '../helpers/models';

type AppProps = {
  apiBasePath: string;
  canCreateNewApplication: boolean;
  maxNumberOfApplications: number;
  isAdmin: boolean;
  availableScopes: Scope[];
}

export const ApiBasePathContext = createContext(null);

const App = ({
  apiBasePath,
  canCreateNewApplication,
  maxNumberOfApplications,
  isAdmin,
}: AppProps) => {
  return (
    <ApiBasePathContext.Provider value={apiBasePath}>
      <BrowserRouter basename={apiBasePath} >
        <Routes>
          <Route path="/" element={<ApplicationsTable canCreateNewApplication={canCreateNewApplication} maxNumberOfApplications={maxNumberOfApplications} isAdmin={isAdmin} />} />
          <Route path="/new" element={<CreateApplicationWizard/>} />
          <Route path="/:applicationId" element={<ApplicationDetails isAdmin={isAdmin} />} />
        </Routes>
      </BrowserRouter>
    </ApiBasePathContext.Provider>
  );
};

export default App;
